import { Text } from '@zillow/constellation-10';
import { useTranslations } from 'next-intl';
import { SkeletonBlock } from '@/src/components/ui/SkeletonBlock';
import { css } from '@/styled-system/css';
import * as styles from './propertyMapModule.styles';

export function PropertyMapSkeleton({ currentUnitName }: { currentUnitName?: string }) {
  const t = useTranslations('hdp');
  return (
    <div className={styles.stack} aria-busy="true">
      <Text>{t('propertyMapDescription')}</Text>
      {currentUnitName && <Text>{t('propertyMapViewingUnit', { name: currentUnitName })}</Text>}
      <div className={styles.toolbar}>
        <SkeletonBlock className={styles.skeletonControl} />
      </div>
      <div className={styles.viewport}>
        <PropertyMapLoadingCanvas />
      </div>
    </div>
  );
}

export function PropertyMapLoadingCanvas() {
  const t = useTranslations('hdp');
  return (
    <div className={styles.status}>
      <SkeletonBlock className={styles.skeletonCanvas} radius="md" />
      <output className={css({ srOnly: true })}>{t('propertyMapLoading')}</output>
    </div>
  );
}
